<form [formGroup]="form" (ngSubmit)="doDirtySubmit()">
  <!-- CNS field -->
  <div class="row" *ngIf="isPublicHC">
    <div class="col-12">
      <lib-form-control>
        <app-spinner-form-control
          [isLoading]="isLoadingDoctorDataByCNS || isValidatingCns"
          [label]="'nouns.cns' | translate"
        >
          <lib-input formControlName="cns" name="cns"></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
  </div>

  <!-- NAME and LAST NAME fields -->
  <div class="row">
    <div class="col-6">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.first-name' | translate">
          <lib-input formControlName="firstName" name="firstName"></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
    <div class="col-6">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.last-name' | translate">
          <lib-input formControlName="lastName" name="lastName"></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
  </div>

  <!-- CPF field -->
  <div class="row">
    <div class="col-12">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.cpf-number' | translate">
          <lib-input formControlName="cpf" name="cpf"></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
  </div>

  <!-- EMAIL and GENDER fields -->
  <div class="row">
    <div class="col-12">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.email' | translate">
          <lib-input formControlName="email" name="email" [trim]="true"></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
    <div class="col-12">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.gender' | translate">
          <lib-select [options]="genderOptions" formControlName="gender"></lib-select>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
  </div>

  <!-- SPECIALIZATION field -->
  <div class="row">
    <div class="col-12">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.specialization" | translate }}</span>
          <lib-select
            [options]="doctorSpecializationOptions"
            formControlName="specialization"
            [size]="'m'"
            (change)="changeSpecializationPsychologist($event.target.value)"
          ></lib-select>
        </label>
      </lib-form-control>
    </div>
  </div>

  <!-- PHONE and DATE OF BIRTH fields -->
  <div class="row">
    <div class="col-6">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.phone' | translate">
          <lib-input formControlName="phone" name="phone" [size]="'m'"></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
    <div class="col-6">
      <lib-form-control>
        <app-spinner-form-control [isLoading]="isLoadingDoctorDataByCNS" [label]="'nouns.date-of-birth' | translate">
          <lib-input
            formControlName="dateOfBirth"
            name="dateOfBirth"
            [mask]="dateInputMask"
            [placeholder]="dateInputPlaceholder"
            [size]="'m'"
          ></lib-input>
        </app-spinner-form-control>
      </lib-form-control>
    </div>
  </div>

  <!-- LICENCES field -->
  <div id="licenses" formArrayName="licenses">
    <div class="row" *ngFor="let licenseForm of licenses.controls; let i = index" [formGroup]="licenseForm">
      <div class="col-4">
        <lib-form-control>
          <label>
            <span libLabel>{{ "nouns.state" | translate }}</span>
            <lib-select [options]="states$ | async" formControlName="state_id" [size]="'m'"></lib-select>
          </label>
        </lib-form-control>
      </div>
      <div class="col-4">
        <lib-form-control>
          <label>
            <span libLabel>{{ "nouns.license" | translate }}</span>
            <lib-input
              formControlName="license"
              type="number"
              [size]="'m'"
              (keyup)="setLicenceToValidate($event.target.value)"
            >
            </lib-input>
          </label>
        </lib-form-control>
      </div>

      <div class="col-2">
        <lib-form-control>
          <label>
            <span libLabel>{{ "actions.remove" | translate }}</span>
            <button
              class="btn-remove"
              libButton
              [appearance]="'danger'"
              [disabled]="licenses.length <= 1"
              [size]="'m'"
              (click)="removeLicense(i)"
            >
              X
            </button>
          </label>
        </lib-form-control>
      </div>
    </div>
  </div>

  <div class="addButton">
    <lib-form-control>
      <label>
        <button libButton [appearance]="'outline'" [size]="'m'" (click)="addLicense(0)">
          +
        </button>
      </label>
    </lib-form-control>
  </div>

  <div class="row" *ngIf="doctor == null">
    <div class="col-12">
      <lib-form-control>
        <label>
          <span libLabel>{{ "nouns.group" | translate }}</span>
        </label>
        <app-doctor-invite-control></app-doctor-invite-control>
      </lib-form-control>
    </div>
  </div>

  <button
    libButton
    [isPending]="isPending"
    type="submit"
    [disabled]="!(formValid$ | async)"
    [appearance]="'outline'"
    [size]="'m'"
  >
    {{ doctor == null ? ("actions.add-to-list" | translate) : ("doctors.edit-button" | translate) }}
  </button>
</form>
